import { render } from "./WebDesign.vue?vue&type=template&id=153fb102&scoped=true"
import script from "./WebDesign.vue?vue&type=script&lang=js"
export * from "./WebDesign.vue?vue&type=script&lang=js"

import "./WebDesign.vue?vue&type=style&index=0&id=153fb102&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153fb102"]])

export default __exports__